import { useEffect } from "react";
import { Outlet, useLocation, Navigate } from "react-router-dom";
import Lenis from "lenis";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import SalesTicker from "@/components/SalesTicker";
import ExitIntent from "@/components/ExitIntent";
import CartDrawer from "@/components/CartDrawer";
import GlitchTransition from "@/components/GlitchTransition";
import Celebration from "@/components/Celebration";
import { useAuth } from "@/context/AuthContext";

const HIDE_TICKER = ["/admin", "/pay", "/payment", "/login", "/register", "/dashboard"];

export default function Layout() {
  const loc = useLocation();

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  useEffect(() => { window.scrollTo(0, 0); }, [loc.pathname]);

  const hideTicker = HIDE_TICKER.some((p) => loc.pathname.startsWith(p));

  return (
    <div className="App min-h-screen bg-black relative">
      <Nav />
      <Celebration />
      <main><GlitchTransition><Outlet /></GlitchTransition></main>
      <Footer />
      {!hideTicker && <SalesTicker />}
      {!hideTicker && <ExitIntent />}
      {!hideTicker && <CartDrawer />}
    </div>
  );
}

export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black">
        <div className="font-mono text-xs tracking-[0.3em] text-white/40 animate-pulse">// AUTHENTICATING...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
